// @ts-nocheck
import * as Types from '@instamenu/data-access';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type EmployerFragment = { __typename?: 'Restaurant', id: string, name?: string | null, dayOffset: number, salesTaxPercent: number, stripeAccountId?: string | null, currentMenu: { __typename?: 'Menu', id: string }, setting: { __typename?: 'RestaurantSetting', payoutHour: number } };

export type UpdateUserMutationVariables = Types.Exact<{
  input: Types.UpdateUserMutationInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserMutationPayload', user?: { __typename?: 'User', id: string, avatarUrl?: string | null, defaultDeliveryAddressId?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, phone?: string | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', id: string } | null, deliveryAddresses: Array<{ __typename?: 'DeliveryAddress', id: string, key: string, city?: string | null, formattedAddress?: string | null, specialInstructions?: string | null, state?: string | null, street?: string | null, street2?: string | null, zip?: string | null, location?: { __typename?: 'Location', lat: number, lon: number } | null }>, employments: Array<{ __typename?: 'Employment', id: string, permissions?: Array<Types.Permission> | null, restaurant: { __typename?: 'Restaurant', id: string, name?: string | null } }>, employers: Array<{ __typename?: 'Restaurant', id: string, name?: string | null, dayOffset: number, salesTaxPercent: number, stripeAccountId?: string | null, currentMenu: { __typename?: 'Menu', id: string }, setting: { __typename?: 'RestaurantSetting', payoutHour: number } }> } | null } | null };

export type PaymentMethodsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, brand?: string | null, last4?: string | null, isDefault: boolean }> | null };

export type DeletePaymentMethodMutationVariables = Types.Exact<{
  input: Types.DeletePaymentMethodMutationInput;
}>;


export type DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod?: { __typename?: 'DeletePaymentMethodMutationPayload', clientMutationId?: string | null } | null };

export type SetDefaultPaymentMethodMutationVariables = Types.Exact<{
  input: Types.SetDefaultPaymentMethodMutationInput;
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod?: { __typename?: 'SetDefaultPaymentMethodMutationPayload', id: string, clientMutationId?: string | null } | null };

export const EmployerFragmentDoc = gql`
    fragment employer on Restaurant {
  id
  currentMenu {
    id
  }
  name
  dayOffset
  salesTaxPercent
  stripeAccountId
  setting {
    payoutHour
  }
}
    `;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserMutationInput!) {
  updateUser(input: $input) {
    user {
      id
      avatarUrl
      defaultDeliveryAddressId
      defaultPaymentMethod {
        id
      }
      deliveryAddresses {
        id
        key
        city
        formattedAddress
        location {
          lat
          lon
        }
        specialInstructions
        state
        street
        street2
        zip
      }
      email
      employments {
        id
        permissions
        restaurant {
          id
          name
        }
      }
      employers {
        ...employer
      }
      firstName
      lastName
      name
      phone
    }
  }
}
    ${EmployerFragmentDoc}`;

export function useUpdateUserMutation() {
  return Urql.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument);
};
export const PaymentMethodsDocument = gql`
    query paymentMethods {
  paymentMethods {
    id
    brand
    last4
    isDefault
  }
}
    `;

export function usePaymentMethodsQuery(options?: Omit<Urql.UseQueryArgs<PaymentMethodsQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>({ query: PaymentMethodsDocument, ...options });
};
export const DeletePaymentMethodDocument = gql`
    mutation deletePaymentMethod($input: DeletePaymentMethodMutationInput!) {
  deletePaymentMethod(input: $input) {
    clientMutationId
  }
}
    `;

export function useDeletePaymentMethodMutation() {
  return Urql.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument);
};
export const SetDefaultPaymentMethodDocument = gql`
    mutation setDefaultPaymentMethod($input: SetDefaultPaymentMethodMutationInput!) {
  setDefaultPaymentMethod(input: $input) {
    id
    clientMutationId
  }
}
    `;

export function useSetDefaultPaymentMethodMutation() {
  return Urql.useMutation<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>(SetDefaultPaymentMethodDocument);
};